import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { timeZoneMap } from "@web-app/utils/helpers";

export default function PillDateTimeTz({
  start,
  end,
  timezone,
  isDateRange,
}: {
  end: Date;
  isDateRange?: boolean;
  start: Date;
  timezone: keyof typeof timeZoneMap;
}) {
  const { getTimezone } = useTimezone();
  const effectiveTimezone = getTimezone(timezone);

  if (isDateRange) {
    // For date range pills, show "MMM DD, YYYY - MMM DD, YYYY"
    const startDate =
      effectiveTimezone === "system"
        ? dayjs(start).format("MMM DD, YYYY")
        : dayjs.utc(start).tz(effectiveTimezone).format("MMM DD, YYYY");

    const endDate =
      effectiveTimezone === "system"
        ? dayjs(end).format("MMM DD, YYYY")
        : dayjs.utc(end).tz(effectiveTimezone).format("MMM DD, YYYY");

    return (
      <>
        {startDate} - {endDate}
      </>
    );
  }

  // For single date pills, show "MMM DD, YYYY h:mm A - h:mm A"
  const dateFormatted =
    effectiveTimezone === "system"
      ? dayjs(start).format("MMM DD, YYYY")
      : dayjs.utc(start).tz(effectiveTimezone).format("MMM DD, YYYY");

  const startTime =
    effectiveTimezone === "system"
      ? dayjs(start).format("h:mm A")
      : dayjs.utc(start).tz(effectiveTimezone).format("h:mm A");

  const endTime =
    effectiveTimezone === "system"
      ? dayjs(end).format("h:mm A")
      : dayjs.utc(end).tz(effectiveTimezone).format("h:mm A");

  return (
    <>
      {dateFormatted} {startTime} - {endTime}
    </>
  );
}
